export default __webpack_public_path__ + "static/aphp-logo-55630e8431302ac4e05564c68f188b9d.jpeg";